import loadable from '@loadable/component';
import Loading from '../components/Loader';

const SetPasswordPage = loadable(
  () => import(/* webpackChunkName: "set-pwd" */ '../containers/SetPasswordPage'),
  {
    fallback: Loading
  }
);

SetPasswordPage.needs = () => {};

export default SetPasswordPage;
